import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut } from './utils'

//ที่อยู่สถานที่ทำงาน
export const saveAddressWork = (request, personId, personalType, projectType) => {
  const url = `${API_ROOT}/${projectType}/${personId}/address/${personalType}/company`
  return doPost(url, request)
}

export const updateAddressWork = (request, personId, addressId, personalType, projectType) => {
  const url = `${API_ROOT}/${projectType}/${personId}/address/${personalType}/company/${addressId}`
  return doPut(url, request)
}

//ที่อยู่ที่ตั้งองค์กร
export const saveOrgAddress = (request, personId, personalType, projectType) => {
  const url = `${API_ROOT}/${projectType}/${personId}/address/${personalType}/organization`
  return doPost(url, request)
}

export const updateOrgAddress = (request, personId, addressId, personalType, projectType) => {
  const url = `${API_ROOT}/${projectType}/${personId}/address/${personalType}/organization/${addressId}`
  return doPut(url, request)
}

//ที่อยู่ตามบัตรประชาชน
export const saveAddressCard = (request, personId, personalType, projectType) => {
  const url = `${API_ROOT}/${projectType}/${personId}/address/${personalType}/id-card`
  return doPost(url, request)
}

export const updateAddressCard = (request, personId, addressId, personalType, projectType) => {
  const url = `${API_ROOT}/${projectType}/${personId}/address/${personalType}/id-card/${addressId}`
  return doPut(url, request)
}

//ที่อยู่จัดส่งเอกสาร
export const saveAddressDeliveryDocument = (request, personId, personalType, projectType) => {
  const url = `${API_ROOT}/${projectType}/${personId}/address/${personalType}/document`
  return doPost(url, request)
}

export const updateAddressDeliveryDocument = (
  request,
  personId,
  addressId,
  personalType,
  projectType
) => {
  const url = `${API_ROOT}/${projectType}/${personId}/address/${personalType}/document/${addressId}`
  return doPut(url, request)
}

//ที่อยู่ปัจจุบัน
// export const saveAddressOffice = (request, personId, personalType, projectType) => {
//   const url = `${API_ROOT}/${projectType}/${personId}/address/${personalType}/company-location`
//   return doPost(url, request)
// }

// export const updateAddressOffice = (request, personId, addressId, personalType, projectType) => {
//   const url = `${API_ROOT}/${projectType}/${personId}/address/${personalType}/company-location/${addressId}`
//   return doPut(url, request)
// }

//Address Template Form 0 - 8
export const getAddressTemplate = (personId, personalType) => {
  const url = `${API_ROOT}/proposal/${personId}/address/${personalType}/template`
  return doGet(url)
}
export const saveAddressTemplate = (request, personId, personalType, projectType) => {
  const url = `${API_ROOT}/${projectType}/${personId}/address/${personalType}/template`
  return doPost(url, request)
}

export const updateAddressTemplate = (request, personId, addressId, personalType, projectType) => {
  const url = `${API_ROOT}/${projectType}/${personId}/address/${personalType}/template/${addressId}`
  return doPut(url, request)
}

//ที่อยู่ปัจจุบัน
export const saveCurrentAddress = (request, personId, personalType, projectType) => {
  const url = `${API_ROOT}/${projectType}/${personId}/address/${personalType}/current`
  return doPost(url, request)
}

export const updateCurrentAddress = (request, personId, addressId, personalType, projectType) => {
  const url = `${API_ROOT}/${projectType}/${personId}/address/${personalType}/current/${addressId}`
  return doPut(url, request)
}
